import React from 'react';
import moment from 'moment-timezone';
import { PreferredRangeEnum } from 'interfaces/waitlist.interface';

const SuccessfulAppointment = ({
    onBack,
    business,
    serviceName,
    serviceProviderName,
    appointmentDate,
    appointmentStartTime,
    joiningWaitlist,
    preferredRange,
}: {
    onBack?(): void;
    business: any;
    serviceName: string | undefined;
    serviceProviderName: string | undefined;
    appointmentDate: any;
    appointmentStartTime: any;
    joiningWaitlist: boolean;
    preferredRange: PreferredRangeEnum;
}) => {
    return joiningWaitlist ? (
        <div className="booking-widget--body" style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="successful--appointment-container">
                <div className="successful--title">You’re On the Waiting List!</div>
                <div className="successful--appointment-details">
                    Your request was sent for {serviceName} with {serviceProviderName}, preferably
                    in the {preferredRange}.
                </div>
                <br />
                <div className="successful--appointment-details">
                    <p
                        style={{
                            paddingLeft: '4px',
                            paddingTop: '30px',
                            paddingBottom: '15px',
                            fontSize: '14px',
                            color: '#5e5e5e',
                        }}>
                        <strong>
                            NOTICE - PLEASE READ: This does not guarantee you an appointment
                        </strong>
                        . This means that you'll appear on the waitlist for the week of{' '}
                        {moment(appointmentDate).format('MMM DD, YYYY')}. If a spot opens up, you
                        may be considered for an appointment.{' '}
                        <strong>
                            If you need a guaranteed appointment, we recommend booking in the next
                            available time slot.
                        </strong>
                    </p>
                </div>
                <div className="bookAgain--button" onClick={onBack}>
                    <button
                        className="btn-book"
                        style={{
                            width: 'auto',
                            backgroundColor: `${
                                business?.booking_widget?.button_bg_color
                                    ? business?.booking_widget?.button_bg_color
                                    : '#cf9d65'
                            }`,
                            color: `
                ${
                    business?.booking_widget?.button_text_color
                        ? business?.booking_widget?.button_text_color
                        : '#27292e'
                }`,
                        }}>
                        Book an Appointment
                    </button>
                </div>
            </div>
        </div>
    ) : (
        <div className="booking-widget--body" style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="successful--appointment-container">
                <div className="successful--title">Appointment successfully booked.</div>
                <div className="successful--appointment-details">
                    {serviceName} with {serviceProviderName} on{' '}
                    {moment(appointmentDate).format('dddd, MMM DD, YYYY')} at{' '}
                    {moment(appointmentStartTime, 'HH:mm').format('hh:mm a')}
                </div>
                <div className="bookAgain--button" onClick={onBack}>
                    <button
                        className="btn-book"
                        style={{
                            width: 'auto',
                            backgroundColor: `${
                                business?.booking_widget?.button_bg_color
                                    ? business?.booking_widget?.button_bg_color
                                    : '#cf9d65'
                            }`,
                            color: `
                    ${
                        business?.booking_widget?.button_text_color
                            ? business?.booking_widget?.button_text_color
                            : '#27292e'
                    }`,
                        }}>
                        Book Another Appointment
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SuccessfulAppointment;
